<script setup lang="ts">
import LPanel from './lpanel.vue';
const linkstyle = 'border-b-1 border-transparent hover:border-slate-300   text-center py-1 px-4';
const items = [
    {
        label: 'Sarpsborgveien',
        to: '/'
    },
    {
        label: 'Ansatte',
        to: '/ansatte'
    },
    {
        label: 'Kontakt',
        to: '/kontakt'
    },
    {
        label: 'Åpningstider',
        to: '/apningstider'
    },
    {
        label: 'Tjenester',
        to: '/tjenester'
    },
    {
        label: 'Priser',
        to: '/priser'
    },
    {
        label: 'Admin',
        to: '/admin'
    }
]
</script>
<template>
    <div class="mainColorBackground">
        <div class="flex flex-row justify-around py-4 ">
            <div class="flex flex-col w-1/2 items-center justify-center">
                <a href="/" class="w-4/6">
                    <p class="font-bold text-2xl">Sarpsborgveien Legesenter</p>
                </a>
                <p class="w-4/6 "><a href="tel:69283150">69283150</a></p>
                <a href="https://www.google.com/maps/place/Sarpsborgveien 7 E,+1640+Råde" target="_blank"
                    class="w-4/6 ">Sarpsborgveien 7 E, 1640 Råde</a>
            </div>
            <div class="flex flex-col w-1/2 items-center">
                <NuxtLink v-for="item in items" :key="item.to" :to="item.to" :class="linkstyle">{{ item.label }}
                </NuxtLink>
            </div>
        </div>
    </div>
</template>
